module.exports = __webpack_public_path__ + "26fa5fe2e8fa2ad7422167640572c5df.svg";